import suggestApi, { IParamSuggestApi } from '@/apis/suggest/api';
import utils from '@/utils';
import { useInfiniteQuery, useQuery, useQueryClient } from '@tanstack/react-query';

const suggestService = {
  useSearch: ({ key, limit, offset, search }: IParamSuggestApi = {}) => {
    return useQuery({
      queryKey: ['suggests', key, limit, search, offset],
      queryFn: () => suggestApi.suggest({ key, limit, offset, search }),
    });
  },

  useGetSuggestInfinite: ({ key, limit, offset, search }: IParamSuggestApi = {}) => {
    const query = useInfiniteQuery({
      queryKey: ['getSuggestInfinite', key, limit, search, offset],
      queryFn: ({ pageParam }) => suggestApi.suggest({ key, limit, offset: pageParam, search }),
      getNextPageParam: (lastPage) => utils.parseQueryParams(lastPage?.meta?.next).offset,
      initialPageParam: 0,
    });
    return query;
  },

  useGetTags: ({ limit = 10e4, offset, search }: IParamSuggestApi = {}) => {
    return useQuery({
      queryKey: ['getTags', limit, offset, search],
      queryFn: () => suggestApi.getTags({ limit, offset, search }),
      gcTime: 5 * 60 * 1000,
      staleTime: 1 * 60 * 1000,
    });
  },
  usePrefetchQuery: () => {
    const queryClient = useQueryClient();
    return ({ key, limit, offset, search }: IParamSuggestApi = {}) => {
      queryClient.prefetchQuery({
        queryKey: ['suggests', key, limit, search, offset],
        queryFn: () => suggestApi.suggest({ key, limit, offset, search }),
      });
    };
  },
};

export default suggestService;
